<app-modal-template
	id="send-kudos-modal"
	(saveClicked)="sendKudos()"
	(cancelClicked)="cancel()"
	[iconId]="16"
	[title]="title"
	[working]="saving"
>
	<!-- Loading Indicator -->
	<app-spinner *ngIf="loading"></app-spinner>

	<!-- Kudos Form -->
	<form [formGroup]="sendKudosForm" *ngIf="!loading" [appFormErrorList]="sendKudosForm.errors">
		<!-- Send To-->
		<mat-form-field class="full-width">
			<mat-label>Send To</mat-label>
			<input
				type="text"
				matInput
				id="send-kudos-to-input"
				formControlName="kudosReceiver"
				[matAutocomplete]="auto"
				placeholder="Start typing a name then select the user from the list of displayed options"
				(blur)="sendToBlur()"
			/>
			<mat-autocomplete
				#auto="matAutocomplete"
				[displayWith]="displayChoiceName"
				(optionSelected)="userSelected()"
			>
				<mat-option
					*ngFor="let user of filteredOptions | async"
					[value]="user"
					matTooltip="{{ user.email }}"
					matTooltipPosition="right"
				>
					{{ user.firstName }} {{ user.lastName }}
				</mat-option>
			</mat-autocomplete>
			<mat-error [appFormError]="sendKudosForm.get('kudosReceiver').errors"></mat-error>
		</mat-form-field>

		<!-- Kudo Types -->
		<mat-radio-group
			formControlName="kudosSelected"
			class="mb-md"
			style="display: grid; grid-template-columns: repeat(auto-fit, minmax(200px, 1fr)); grid-gap: 16px"
		>
			<mat-radio-button *ngFor="let kudosType of kudosTypes" [value]="kudosType.kudoId">
				<app-db-icon
					[iconId]="kudosType.iconId"
					[fixedWidth]="true"
					style="font-size: 20pt; vertical-align: middle"
					class="mr-sm"
				></app-db-icon>
				<span>{{ kudosType.name }}</span>
			</mat-radio-button>
			<mat-error
				[appFormError]="sendKudosForm.get('kudosSelected').errors"
				*ngIf="sendKudosForm.get('kudosSelected').touched"
				class="error"
			></mat-error>
		</mat-radio-group>
	</form>
</app-modal-template>
